import { useLingui } from '@lingui/react/macro';
import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';

import { Pages } from 'modules/navigation/domain/enums/pages';
import { KitSwatch } from 'shared/components/kit';
import { KitElement } from 'shared/kit/kit-element';
import { ALL_KIT_TYPES, KIT_TYPE_LABELS } from 'shared/kit/kit-type';
import { TeamViewTab } from 'modules/teams/domain/enums/team-view-tab';
import UDTabs from 'ud-ui/components/tabs';
import { Tab } from 'ud-ui/components/tabs/interfaces';
import UDText from 'ud-ui/components/text';

import { KitFormValues, toElementStates } from './kit-state';

interface KitTypeTabsProps {
  /** Элементы формы вида спорта — из них собираются мини-свотчи в подписи таба. */
  elements: KitElement[];
}

/**
 * Второй ряд табов карточки команды: комплекты формы.
 *
 * Компонент обязан жить внутри Formik-контекста (свотчи показывают текущие,
 * ещё не сохранённые цвета) и **выше** вложенного `<Routes>`: `UdTab` навигирует
 * относительным путём, и из контекста роута `:kitType` клик по «Гостевая» дал бы
 * `/teams/1/kits/home/away`.
 */
export const KitTypeTabs: React.FC<KitTypeTabsProps> = ({ elements }) => {
  const { values } = useFormikContext<KitFormValues>();
  const { t } = useLingui();

  const tabs = useMemo<Tab[]>(
    () =>
      ALL_KIT_TYPES.map((kitType) => ({
        hash: kitType,
        label: (
          // Свотчи и подпись — в строку: `UdTab` рисует таб кнопкой фиксированной
          // высоты, и второй ряд в подписи из неё вылезает.
          <span className="flex flex-row items-center gap-2 whitespace-nowrap">
            <KitSwatch elements={elements} elementStates={toElementStates(values[kitType])} />
            <UDText type="subhead">{t(KIT_TYPE_LABELS[kitType])}</UDText>
          </span>
        ),
      })),
    [elements, t, values],
  );

  return <UDTabs tabs={tabs} defaultTab={tabs[0]} activeRoutePattern={`${Pages.TEAMS.EDIT}/${TeamViewTab.KITS}`} />;
};

export default KitTypeTabs;
